module.exports = __webpack_public_path__ + "static/img/bg.6282da1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/Plan/bg.jpg
// module id = KGTM
// module chunks = 1